export default {"src":"/_next/static/media/loader.b40dbed7.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};